import { selectStation,insertStation,updateStation,deleteStation } from "../../api/config/modules/SiteFile";

const state = {
    selectStation: {},
    insertStation: {},
    updateStation: {},
    deleteStation: {},
};

const mutations = {
  SET_SELECTSITE: (state, selectStation) => {
    state.selectStation = selectStation;
  },
  SET_INSERTSITE: (state, insertStation) => {
    state.insertStation = insertStation;
  },
  SET_UPDATESITE: (state, updateStation) => {
    state.updateStation = updateStation;
  },
  SET_DELETESITE: (state, deleteStation) => {
    state.deleteStation = deleteStation;
  },
};

const actions = {
  GET_SELECTSITE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectStation(data)
        .then((res) => {
          commit("SET_SELECTSITE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTSITE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertStation(data)
        .then((res) => {
          commit("SET_INSERTSITE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATESITE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateStation(data)
        .then((res) => {
          commit("SET_UPDATESITE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETESITE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteStation(data)
        .then((res) => {
          commit("SET_DELETESITE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
